import { createStyles, Theme, WithStyles } from '@material-ui/core/styles';

export const styles = (theme: Theme) => createStyles({
  about: {
    '@media (max-width: 600px)': {
      paddingBottom: theme.spacing(5),
    },
    background: 'none',
    flex: '1',
    position: 'relative',
    paddingBottom: '1em'
  },
  aboutContainer: {
    width: '100%',
  },
  aboutContext: {
    '@media (max-width: 960px)': {
      textAlign: 'center',
    },
    '@media (min-width: 960px)': {
      position: 'relative',
      top: '50%',
      transform: 'translateY(-50%)',
    },
  },
  aboutContextWrapper: {
    '@media (max-width: 960px)': {
      margin: '0 auto',
    },
    maxWidth: '80%',
  },
  context: {
    height: '100%',
  },
  cv: {
    paddingTop: theme.spacing(4),
  },
  description: {
    '@media (max-width: 600px)': {
      fontSize: '0.9rem',
    },
    textAlign: 'left',
  },
  profileImage: {
    '@media (max-width: 960px)': {
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '100%',
    },
    '@media (min-width: 960px)': {
      padding: theme.spacing(3),
      transform: 'translateY(-50%)',
      width: '80%',
    },
    objectFit: 'contain',
    position: 'relative',
    top: '50%',
  },
  profileImageContainer: {
    '@media (max-width: 960px)': {
      margin: '0 auto',
      maxHeight: '80%',
      maxWidth: '40%',
    },
    '@media (min-width: 960px)': {
      maxHeight: '100%',
      maxWidth: '100%',
    },
  },
  title: {
    '@media (max-width: 600px)': {
      fontSize: '2rem',
    },
    '@media (min-width: 600px)': {
      fontSize: '3rem',
    },
  },
  role: {
    '@media (max-width: 600px)': {
      fontSize: '0.8rem',
    },
    color: 'grey',
    marginTop: '10px',
  },
  snsContainer: {
    '@media (max-width: 960px)': {
      justifyContent: 'center',
    },
  },
  snsIcon: {
    fontSize: '2.0rem',
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    paddingTop: theme.spacing(3),
  },
  snsLink: {
    color: 'black'
  },
});

export type Styles = WithStyles<typeof styles>;
